import { API, authClient } from "../index";

export const getOfferDefaultsConfig = (accessToken) =>
  authClient(accessToken).get(`${API}/config/general/offers`);

export const updateOfferDefaultsConfig = (config, accessToken) =>
  authClient(accessToken).put(`${API}/config/general/offers`, config);

export const getOperarioMobileConfig = (accessToken) =>
  authClient(accessToken).get(`${API}/config/general/operarios`);

export const updateOperarioMobileConfig = (config, accessToken) =>
  authClient(accessToken).put(`${API}/config/general/operarios`, config);

export const getCompanyConfig = (accessToken) =>
  authClient(accessToken).get(`${API}/config/general/company`);

export const updateCompanyConfig = (config, accessToken) =>
  authClient(accessToken).put(`${API}/config/general/company`, config);

export const uploadCompanyLogo = (file, accessToken) => {
  const body = new FormData();
  body.append("file", file);
  return authClient(accessToken).post(`${API}/config/general/company/logo`, body);
};

export const previewCompanySignature = (firmaHtml, accessToken) =>
  authClient(accessToken).post(`${API}/config/general/company/signature-preview`, { firma_html: firmaHtml });

export const getAIPromptsConfig = (accessToken) =>
  authClient(accessToken).get(`${API}/config/general/prompts`);

export const updateAIPromptsConfig = (prompts, accessToken) =>
  authClient(accessToken).put(`${API}/config/general/prompts`, prompts);
